import { Button } from "@ews-admin/global-design-system";
import React from "react";
import { useTranslation } from "react-i18next";

import { PageLoadError } from "../../utils/lazy-page";

export const PageLoadFailed = () => {
  const { t } = useTranslation();

  return (
    <div
      role="alert"
      data-testid="page-load-failed"
      className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-4 text-center"
    >
      <h1 className="text-xl font-semibold text-gray-900">
        {t("pageLoad.title")}
      </h1>
      <p className="max-w-md text-gray-600">{t("pageLoad.message")}</p>
      <Button onClick={() => window.location.reload()}>
        {t("pageLoad.reload")}
      </Button>
    </div>
  );
};

interface PageLoadBoundaryProps {
  children: React.ReactNode;
}

interface PageLoadBoundaryState {
  error: Error | null;
}

/** MED-1743: a page whose code could not be downloaded, not a blank screen. */
export class PageLoadBoundary extends React.Component<
  PageLoadBoundaryProps,
  PageLoadBoundaryState
> {
  state: PageLoadBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): PageLoadBoundaryState {
    return { error };
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    if (error instanceof PageLoadError) return <PageLoadFailed />;
    throw error;
  }
}
